import { useState } from "react";
import type { EvidenciaOut } from "@/lib/api";

// Ícono por tipo de archivo (fallback cuando no hay thumbnail).
export function iconoArchivo(mime: string, nombre: string): string {
  const n = nombre.toLowerCase();
  const m = mime.toLowerCase();
  if (m.startsWith("video/")) return "🎬";
  if (m === "application/pdf" || n.endsWith(".pdf")) return "📄";
  if (/\.(xlsx?|ods|csv)$/.test(n) || m.includes("spreadsheet") || m.includes("ms-excel"))
    return "📊";
  if (/\.(docx?|odt|rtf)$/.test(n) || m.includes("wordprocessing") || m.includes("msword"))
    return "📝";
  if (/\.(zip|rar|7z|gz)$/.test(n) || m.includes("zip") || m.includes("compressed"))
    return "🗜️";
  if (m.startsWith("text/") || /\.(txt|log|cfg|ini)$/.test(n)) return "🗒️";
  return "📎";
}

// ¿El server le puede sacar thumbnail? (video = frame; pdf/word/excel =
// página 1 — espejo de tiene_thumb_documento del backend).
export function tieneThumb(mime: string, nombre: string): boolean {
  const n = nombre.toLowerCase();
  const m = mime.toLowerCase();
  return (
    m.startsWith("video/") ||
    m === "application/pdf" ||
    n.endsWith(".pdf") ||
    /\.(docx?|odt|rtf|xlsx?|ods)$/.test(n) ||
    m.includes("wordprocessing") ||
    m.includes("msword") ||
    m.includes("spreadsheet") ||
    m.includes("ms-excel")
  );
}

// Thumbnail real vía el endpoint /thumb (frame de video o página 1 del
// documento, cacheado por sha en el server). Si falla, cae al ícono.
export function ThumbArchivo({
  ev,
  className,
  fallbackClassName,
}: {
  ev: EvidenciaOut;
  className: string;
  fallbackClassName: string;
}) {
  const [error, setError] = useState(false);
  if (error)
    return (
      <span className={fallbackClassName}>{iconoArchivo(ev.mime, ev.nombre_original)}</span>
    );
  return (
    <img
      src={`/api/evidencias/${ev.id}/thumb`}
      alt={ev.nombre_original}
      loading="lazy"
      className={className}
      onError={() => setError(true)}
    />
  );
}
